import { type Achievement } from '@lingoda/monolith-graphql';

export const getIsClaimable = ({ achieved, claimed, claimId }: Achievement) => {
    return achieved && !claimed && !!claimId;
};
